<template>
  <div>
    <forum-article-block :hideFooter="viewRestricted" showImage disableClick showAnswerBtn showFullWhoInDescription></forum-article-block>
    <div v-if="$store.state.forum.showMainAnswerBlock">
      <vue-editor useCustomImageHandler @image-added="handleImageAdded" class="wysiwygStyle wysiwygReduced" v-model="$store.state.forum.wysiwygEntryAnswer"></vue-editor>
      <base-button style="margin: 1rem !important" class="reply-entry-btn" @click="sendMessage">{{$t('send')}}</base-button>
      <base-button style="margin: 1rem !important" gray outline @click="goBack">{{$t('cancel')}}</base-button>
    </div>
    <div class="verticalCenter" v-if="viewRestricted">
      <div style="margin-bottom: 2%;" class="forumArticle">
        <p style="margin: 1.5rem">{{$t('loginFromArticle')}}
          <base-button  @click="logIn(`quienseapunta/${entryId}`)" class="btn btn-primary fixed-padding-btn-forum"><span>{{ $t('accessBtn') }}</span>
            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" color="white"/>
          </base-button>
        </p>
      </div>
    </div>
    <forum-message-block v-else :numPrincipalReplies="numReplies" :entryReferenceId="entryId"></forum-message-block>
  </div>
</template>

<script>
import forumMixin from '@/mixins/forum.mixin'
import { VueEditor } from 'vue2-editor'
// import _ from 'lodash'

export default {
  name: 'forum-thread',
  components: {
    'base-button': () => import('@/components/base/buttons/BaseButton').then(m => m.default),
    'forum-article-block': () => import('./ForumArticleBlock').then(m => m.default),
    'forum-message-block': () => import('./ForumMessageBlock').then(m => m.default),
    VueEditor
  },
  props: {
  },
  mixins: [forumMixin],
  data () {
    return {
      entryId: null,
      numReplies: null,
      viewRestricted: false
    }
  },
  created () {
    if (!this.$store.getters['session/isLogged']) {
      this.viewRestricted = true
    }
    if (!this.$store.state.forum.editingEntry) {
      this.$store.state.forum.showMainAnswerBlock = false
    }
    this.entryId = this.$route.params.id
    this.getForumEntry()
  },
  computed: {
  },
  methods: {
    getForumEntry () {
        this.$api.get('/Forum/GetEntry', {params: {entryId: this.entryId, sectionId: this.$store.state.forum.sectionId}}).then((response) => {
          if (response.data) {
            this.$store.state.forum.entriesCreatedByUser = response.data.entriesCreatedByUser
            this.$store.state.forum.numEntries = response.data.numEntries
            this.$store.state.forum.articleData = response.data.entryData
            this.numReplies = response.data.entryData[0].numReplies
            this.$store.state.forum.messagesPageNumber = []
            if (!this.viewRestricted) {
              this.getForumMessages(this.entryId)
            }
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
        })
    },
    updatePostData () {
      this.$store.state.forum.messagesPageNumber = []
      this.getForumMessages(this.entryId)
      let article = this.$store.state.forum.articleData.find(item => item.id === this.entryId)
      article.totalMessages = !article.totalMessages ? 1 : ++article.totalMessages
    },
    sendMessage () {
      if (!this.$store.state.forum.wysiwygEntryAnswer) {
        this.$store.dispatch('showDangerAlert', this.$t('emptyMessageError'))
        return
      }

      if (this.$store.state.forum.editingEntry) {
        this.$api.put('/Forum/EditEntry', null, { params: { entryId: this.entryId, description: this.$store.state.forum.wysiwygEntryAnswer } }).then((response) => {
          if (response.data) {
            this.$store.state.forum.wysiwygEntryAnswer = null
            this.$store.state.forum.editingEntry = false
            this.$store.state.forum.showMainAnswerBlock = false
            this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
            this.getForumEntry()
            this.updateLastInteractionDate(this.entryId)
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
        })
      } else {
        this.$api.post('/Forum/SendEntryMessage', {entryReferenceId: this.entryId, message: this.$store.state.forum.wysiwygEntryAnswer, sectionId: this.$store.state.forum.sectionId}).then((response) => {
          if (response.data) {
            this.updatePostData()
            this.$store.state.forum.wysiwygEntryAnswer = null
            this.$store.state.forum.showMainAnswerBlock = false
            if (this.$store.getters['forum/forumMessageWithoutValidation']) {
              this.updateLastInteractionDate(this.entryId)
              this.$store.dispatch('showSuccessAlert', this.$t('messagePublishedSuccessfully'))
            } else {
              this.$store.dispatch('showSuccessAlert', this.$t('messagePendingValidation'))
            }
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
          }
        })
      }
    },
    goBack () {
      this.$store.state.forum.wysiwygEntryAnswer = null
      this.$store.state.forum.editingEntry = false
      this.$store.state.forum.showMainAnswerBlock = false
    }
  }
}
</script>

<style lang="scss">
.reply-entry-btn{
  margin-bottom: 2% !important;
  @include media(mobile, tablets) {
    margin-top: 2% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-community/forum/ForumThread.vue